import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { Studio } from '@/modules/Studios/types'
import CreateStudioInfo from '@/modules/Studios/components/create-studio/CreateStudioInfo.vue'
import CreateStudioAdmins from '@/modules/Studios/components/create-studio/CreateStudioAdmins.vue'
import CreateStudioTeachers from '@/modules/Studios/components/create-studio/CreateStudioTeachers.vue'
import CreateStudioStudents from '@/modules/Studios/components/create-studio/CreateStudioStudents.vue'
import CreateStudioSocials from '@/modules/Studios/components/create-studio/CreateStudioSocials.vue'
import CreateStudioLocation from '@/modules/Studios/components/create-studio/CreateStudioLocation.vue'
import { StudioApi } from '@/enitites/studio'
import { useImage } from '@/shared/composables/image'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateStudio',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const { saveImage, getStudioImage } = useImage()

const stages = [
  CreateStudioInfo,
  CreateStudioLocation,
  CreateStudioSocials,
  CreateStudioAdmins,
  CreateStudioTeachers,
  CreateStudioStudents,
]
const currentStage = ref(0)
const studio = ref<Studio>()
const studioImage = ref('')
const studioImageFile = ref<FileList | null>(null)

// Image handling
const changeImage = (e: Event) => {
  const target = e.target as HTMLInputElement
  const filesImg = target.files

  if (!filesImg || filesImg.length === 0) return

  const reader = new FileReader()
  reader.onload = (event) => {
    studioImage.value = event.target?.result as string
    studioImageFile.value = filesImg
  }
  reader.readAsDataURL(filesImg[0])
}

// Studio update
const handleUpdateStudio = async () => {
  if (!studio.value) return

  // Handle image upload if on first stage
  if (currentStage.value === 0 && studioImageFile.value) {
    studio.value.image = await saveImage(studioImageFile.value[0])
  }

  await StudioApi.updateStudio(studio.value)
}

const publishStudio = async () => {
  if (!studio.value) return
  const publishedStudio = await StudioApi.publishStudio(studio.value.id)
  if (publishedStudio) {
    await router.push({ name: 'Studio', params: { id: String(studio.value.id) } })
  }
}

const toNextStage = async () => {
  await handleUpdateStudio()

  // Navigate to the next stage
  const nextStage = currentStage.value + 1
  if (stages[nextStage]) {
    currentStage.value = nextStage
  } else {
    // If it's the last stage, publish the studio
    await publishStudio()
  }
}

const toPreviousStage = async () => {
  await handleUpdateStudio()

  const previousStage = currentStage.value - 1
  if (stages[previousStage]) {
    currentStage.value = previousStage
  }
}

const cancelStudioCreation = async () => {
  if (!studio.value) return
  await StudioApi.deleteStudio(studio.value.id)
  await router.push({ name: 'Studios' })
}

onMounted(async () => {
  const studioId = route.params.id
  studio.value = await StudioApi.fetchStudio(studioId)

  // Initialize studio image if studio has an image
  if (studio.value && studio.value.image) {
    studioImage.value = getStudioImage(studio.value.image, 1000)
  }
})

return { __sfc: true,router, route, saveImage, getStudioImage, stages, currentStage, studio, studioImage, studioImageFile, changeImage, handleUpdateStudio, publishStudio, toNextStage, toPreviousStage, cancelStudioCreation }
}

})